import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const CoursesContainer = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
`;

const PageTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 40px;
`;

const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  padding: 20px;
`;

const CourseCard = styled.div`
  background: #fff;
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`;

const CourseIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 15px;
  color: #f9d71c;
`;

const CourseTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 10px;
`;

const CourseDescription = styled.p`
  color: #666;
  line-height: 1.6;
`;

const Courses = () => {
  const navigate = useNavigate();

  return (
    <CoursesContainer>
      <PageTitle>Our Courses</PageTitle>
      <CourseGrid>
        <CourseCard onClick={() => navigate('/course/phd')}>
          <CourseIcon>🎓</CourseIcon>
          <CourseTitle>PhD Astrology</CourseTitle>
          <CourseDescription>Advanced research in Vedic astrology</CourseDescription>
        </CourseCard>

        <CourseCard onClick={() => navigate('/course/ma')}>
          <CourseIcon>📚</CourseIcon>
          <CourseTitle>MA Astrology</CourseTitle>
          <CourseDescription>Master's program in astrological sciences</CourseDescription>
        </CourseCard>

        <CourseCard onClick={() => navigate('/course/ba')}>
          <CourseIcon>📖</CourseIcon>
          <CourseTitle>BA Astrology</CourseTitle>
          <CourseDescription>Bachelor's degree in fundamental astrology</CourseDescription>
        </CourseCard>

        <CourseCard onClick={() => navigate('/course/diploma')}>
          <CourseIcon>📜</CourseIcon>
          <CourseTitle>Diploma</CourseTitle>
          <CourseDescription>Professional diploma in practical astrology</CourseDescription>
        </CourseCard>
      </CourseGrid>
    </CoursesContainer>
  );
};

export default Courses;